/**
 * 保存除kline除复权以外的其他数据
 */
import Util from '../../../util/index.js';
import BaseDB from './basedb';
import { tradeSectionGrp } from '../../cache.js';
import {
  TREND_ONE,
  TREND_FIVE,
  KLINE_ONEDAY,
  TREND_TYPE,
} from '../../../viewmodel/index.js';
import {
  checkFutures,
  checkHKM,
  getIndex,
  transformTime,
  checkAmerican,
} from '../../../controller/util.js';
import el from "element-ui/src/locale/lang/el";
/**** 分时五档明细 ****/
const { TREND_WD, TREND_MX, TREND_CJ } = TREND_TYPE;
export default class TrendDB extends BaseDB {
  constructor(props) {
    super(props);
    this.queryKeys = {
      [TREND_ONE]: Symbol(TREND_ONE),
      [KLINE_ONEDAY]: Symbol(KLINE_ONEDAY),
      [TREND_FIVE]: Symbol(TREND_FIVE),
      [TREND_ONE + 'ClosePx']: Symbol(TREND_ONE + 'ClosePx'),
      [TREND_FIVE + 'ClosePx']: Symbol(TREND_FIVE + 'ClosePx'),
      [KLINE_ONEDAY + 'ClosePx']: Symbol(KLINE_ONEDAY + 'ClosePx')
    };
    [
      '_calcTrendData',
      'getReal',
      'getTick',
      'getFundflow',
      'getTrend',
      'getTrendData',
      'getPreClosePx',
      'getTrademinGrp',
      'getTrendDetail',
    ].forEach(method => {
      this[method] = this[method].bind(this);
    });
  }
  /*
  计算分时数据
   */
  _calcTrendData(data, code, period) {
    let { [code]: codeData, fields } = data;
    let _data = {};
    let tempArr = [];
    // 最新价和均价
    const keyList = ['last_px', 'avg_px', 'index_rise_trend', 'index_fall_trend'];
    keyList.forEach(key => {
      let _index = getIndex(fields, key);
      _data[key] = codeData.map(a => { return { value: a[_index] } });
    });
    if (period == TREND_ONE) {
      _data.indexRF = []
      _data.index_rise_trend.forEach((key, index) => {
        const rf_value = key.value - _data.index_fall_trend[index].value
        _data.indexRF.push({
          value: rf_value,
          barColor: rf_value > 0 ? 1 : 0
        })
      })
    }
    // 时间
    const _timeIndex = getIndex(fields, 'min_time');
    // TODO 数据量大耗时较多，平均一条1ms
    const isAmerican = checkAmerican(code);
    _data.min_time = codeData.map(a => a[_timeIndex]);
    // _data.min_time = codeData.map(a => transformTime({timeStamp: a[_timeIndex], code, isAmerican}));
    // TODO 期货夜市需单独处理
    if (period === TREND_FIVE) {
      // 五日成交量隔日之间不需要相减
      const len = codeData.length;
      const finance_mic = code.split(".")[1];
      const { singleAmount } = tradeSectionGrp[finance_mic];
      const total = Math.min(Math.ceil(len / singleAmount), 5);
      for (let i = 0; i < total; i++) {
        // 五日最后一天包含0930等开盘价，数据长度比singleAmount多1
        const amount = i * singleAmount;
        const bussinessArr = i === total - 1 ? codeData.slice(amount, amount + singleAmount + 1) : codeData.slice(amount, amount + singleAmount);
        tempArr.push(bussinessArr);
      }
    } else if (period === TREND_ONE) {
      tempArr.push(codeData);
    }
    const _amountIndex = getIndex(fields, 'business_amount');
    let _amountArray = [];
    tempArr.forEach((arr, j) => {
      for (let k in arr) {
        let obj = {}
        if (j == 0 && k == 0) {
          obj.value = arr[k][_amountIndex]
        } else if (k == 0 && j > 0) {
          // 举例：不足5日的沪深新股，当日分时241条，以240截取时，1500可能会被截到下一天，此处特意判断，如果相同天数则进行成交量的减操作
          let last_day = Math.floor(tempArr[j - 1][tempArr[j - 1].length - 1][0] / 10000 % 10000)
          let curr_day = Math.floor(arr[k][0] / 10000 % 10000)
          let last_amount = tempArr[j - 1][tempArr[j - 1].length - 1][_amountIndex]
          let curr_amount = arr[k][_amountIndex]
          obj.value = last_day == curr_day ? curr_amount - last_amount : curr_amount
          // 期货存在前一天的夜盘 不做以上处理
          if (checkFutures(code)) {
            obj.value = curr_amount
          }
        } else {
          obj.value = arr[k][_amountIndex] - arr[k - 1][_amountIndex]
        }
        obj.value < 0 && (obj.value = 0) // 相减出现负数的情况，此处手动修正，以免影响整体成交量
        _amountArray.push(obj)
      }
    });
    _data['business_amount'] = _amountArray;
    return _data;
  }

  async getTrendData({ isAppend = false, crc, minTime, key } = {}) {
    let dataType = 'real_trend';
    const code = this.code;
    const period = this.period;
    if (period === TREND_FIVE) {
      // 首次加载五日分时
      dataType = 'trend5day';
    }
    let param = { code, dataType };
    if (isAppend) {

      // 增量获取trend数据
      param = { ...param, crc, minTime };
    }
    var rst = await this.api.trend(param);
    if (dataType == "trend5day") {
      rst = await this.api.mintime5(param);
    }
    let { trend } = rst.data;
    if (!trend[code] || trend[code].length == 0) {
      return { ...trend, code, period };
    }
    if (isAppend) {
      // 拼接本地数据
      if (this.has(key)) {
        const { data } = this.get(key);
        let oldTrend = data[code];
        let newTrend = trend[code];
        // 日期对比改为旧数据最后一条和新数据，因为期货有前一天的夜盘
        let isSameDay = Math.floor(oldTrend[oldTrend.length - 1][0] / 10000) != Math.floor(newTrend[0][0] / 10000)
        if (period == TREND_ONE && isSameDay) {
          // 后台返回数据日期和旧数据非同一天
          trend[code] = newTrend
        } else {
          if (Util.isValidArray(oldTrend) && Util.isValidArray(newTrend)) {
            // oldTrend.pop();
            oldTrend = oldTrend.slice(0, oldTrend.length - 1);
          }
          const newtrendType = oldTrend.some(function(item, index) {
            return item[0] == newTrend[0][0]
          })
          if (!newtrendType) {
            trend[code] = [...oldTrend, ...newTrend];
            // trend[code] = [...newTrend];
          } else {
            // oldTrend.pop();
            oldTrend = oldTrend.slice(0, oldTrend.length - 1);
            trend[code] = [...oldTrend, ...newTrend];
            // trend[code] = [...newTrend];
          }
          trend[code] = [ ...newTrend];
        }
      }
    }
    try {
      let trendCode = trend[code];
      const time = trendCode[trendCode.length - 1][0]
      let minTime = time % 10000;
      if (code.indexOf('688') > -1 && minTime > 1500) {
        // 科创板时间更新至1530，但是只展示到1500
        minTime = 1500
      }
      let crc;
      if (trend.hasOwnProperty('crc')) {
        crc = trend.crc[code];
      } else {
        // crc = Number.parseInt(time / 10000);
        dataType = 'trend';
        param = { ...param, dataType }
        const rst = await this.api.trend(param);
        crc = rst.data.trend.crc[code]
      }
      trend = { ...trend, crc, minTime };
    } catch (e) {
      console.log(e)
    }

    // 科创板数据显示到1500为止 （当日分时260条）
    if ((code.indexOf('688') > -1) && (period == TREND_ONE)) {
      let index = trend[code].findIndex((item, i) => {
        if (item[0] % 10000 == 1500) {
          return i
        }
      })
      if (index !== -1) {
        trend[code] = trend[code].slice(0, index + 1)
      }
    } else if ((code.indexOf('688') > -1) && (period == TREND_FIVE)) {
      // 科创板5日分时为240*4+241
      const finance_mic = code.split(".")[1];
      const { singleAmount } = tradeSectionGrp[finance_mic];
      const total = Math.min(Math.ceil(trend[code].length / singleAmount), 5);
      for (let i = 0; i < total; i++) {
        const amount = i * singleAmount;
        const arr = i === total - 1 ? trend[code].slice(amount, amount + singleAmount + 1) : trend[code].slice(amount, amount + singleAmount);
        if (!arr || !/0930$|0931$/ig.test(arr[0][0])) {
          // 若arr不以0930或者0931开始，那表明不是新的一天，而是科创板1500以后的数据，进行截断
          trend[code] = trend[code].slice(0, trend[code].length - arr.length + 1)
        }
      }
      // 五日超出的进行截断
      trend[code] = trend[code].slice(0, 1202)
    }
    return { ...trend, code, period };
  }
  /*
  获取资金博弈数据
   */
  async getTrademinGrp() {
    const code = this.code;
    const rst = await this.api.fundflowTradeMin({ code });
    const { fundflow_trademin_grp, fields } = rst.data;
    return { fundflow: { fundflow_trademin_grp, fields } };
  }
  /*
  获取昨收价
   */
  async getPreClosePx() {
    let code = this.code;
    let period = this.period;
    let rst = null;
    let preClosePx = null;
    let basePx = null; // 用作画图的y轴坐标中间点
    let dataCount = period === TREND_ONE ? 2 : 6;
    if (!checkFutures(code) && period === TREND_FIVE) {
      rst = await this.api.kline({
        get_type: "offset",
        prod_code: code,
        candle_period: KLINE_ONEDAY,
        fields: "close_px",
        data_count: dataCount
      });
      let { [code]: closeData, fields } = rst.data.candle;
      if (Util.isValidArray(closeData)) {
        let _closePx = getIndex(fields, 'close_px');
        preClosePx = closeData.slice(-1)[0][_closePx];
        basePx = closeData[0][1];
        return { basePx, code, period };
      }
    }
    // 其余分时的昨收价取自real
    return { code, period };
  }
  /*
  分时图五档
   */
  async getReal(perHand) {
    const code = this.code;
    try {
      let rst = await this.api.real({ code, fields: 'bid_grp,offer_grp,hq_type_code,circulation_amount,turnover_ratio,pe_rate,trade_status,prod_name' });
      const { [code]: codeData, fields } = rst.data.snapshot;
      const realData = {};
      [
        'circulation_amount',
        'turnover_ratio',
        'pe_rate',
        'trade_status',
      ].map(item => {
        const _index = getIndex(fields, item);
        realData[item] = codeData[_index];
      });
      const getWDData = key => {
        const _index = getIndex(fields, key);
        const arrayStr = codeData[_index];
        const array = arrayStr.match(/([\.\d]+),([\.\d]+),\d+/ig);
        const grp = [];
        array.forEach(val => {
          const tempArr = val.split(',');
          if (Util.isArray(tempArr) && tempArr.length > 1) {
            const amount = Math.round(parseFloat(tempArr[1]) / perHand);
            grp.push({
              price: parseFloat(tempArr[0]),
              amount,
            });
          } else {
            grp.push({
              price: 0,
              amount: 0,
            });
          }
        });
        return grp;
      }
      const bid_grp = getWDData('bid_grp');
      const offer_grp = getWDData('offer_grp');
      // offer_grp 卖单按照逆序展示
      offer_grp.reverse();
      return { ...realData, code, bid_grp, offer_grp };
    } catch (e) {
      return { code };
    }
  }
  /*
  分时图明细
   */
  async getTick(perHand) {
    const code = this.code;
    const period = this.period;
    let rst = await this.api.tick({ code });
    const { tick } = rst.data;
    const { [code]: codeData = [], fields } = tick;
    const orderTick = [];
    const businessTimeIndex = getIndex(fields, 'business_time');
    const hqPxIndex = getIndex(fields, 'hq_px');
    const businessAmountIndex = getIndex(fields, 'business_amount');
    const businessDirectionIndex = getIndex(fields, 'business_direction');
    codeData.forEach(item => {
      orderTick.push({
        time: item[businessTimeIndex].toString().replace(/\d+(\d{2})(\d{2})\d{2}/ig, function($0, $1, $2) {
          return $1 + ':' + $2;
        }),
        price: item[hqPxIndex],
        amount: Math.round(item[businessAmountIndex] / perHand),
        direction: item[businessDirectionIndex],
      })
    })
    return { code, tick: orderTick };
  }
  /*
  分时图成交
   */
  async getFundflow(perHand) {
    const code = this.code;
    const period = this.period;
    let rst = await this.api.fundflowDetail({ code, fields: 'date,large_grp,medium_grp,little_grp,super_grp' });
    const { fundflow_order_snapshot_grp } = rst.data;
    if (Util.isValidArray(fundflow_order_snapshot_grp)) {
      const fundflowGrp = fundflow_order_snapshot_grp[0];
      const { super_grp, large_grp, medium_grp, little_grp } = fundflowGrp;
      large_grp.amount_in += super_grp.amount_in;
      large_grp.amount_out += super_grp.amount_out;
      const dataArr = [
        { ...large_grp, legend: '大单', key: 'large_' },
        { ...medium_grp, legend: '中单', key: 'medium_' },
        { ...little_grp, legend: '小单', key: 'little_' },
      ];
      const totalIn = dataArr.reduce((prev, item) => prev + item.amount_in, 0);
      const totalOut = dataArr.reduce((prev, item) => prev + item.amount_out, 0);
      const curryRate = (total, key) => {
        return item => {
          let rate = '-';
          const amount = Math.round(item[key] / perHand);
          if (total !== 0) {
            const r = item[key] / total * 100;
            if (Util.isValidNumber(r)) {
              rate = r.toFixed(0) + '%';
            }
          }
          const primaryKey = item.key + key;
          return { ...item, rate, amount, primaryKey };
        }
      }
      const fundflowIn = dataArr.map(curryRate(totalIn, 'amount_in'));
      const fundflowOut = dataArr.map(curryRate(totalIn, 'amount_out'));
      return { code, fundflowIn, fundflowOut };
    }
    return { code };
  }
  /*
  切换分时图五档明细
   */
  async getTrendDetail(trendStatus, perHand) {
    const code = this.code;
    const period = this.period;
    let data = { code, period, detail: null };
    if (!Util.isUndefined(trendStatus)) {
      switch (trendStatus) {
        case TREND_WD:
          data = await super.query({ fn: this.getReal.bind(this, perHand), key: trendStatus });
          break;
        case TREND_MX:
          data = await super.query({ fn: this.getTick.bind(this, perHand), key: trendStatus });
          break;
        case TREND_CJ:
          data = await super.query({ fn: this.getFundflow.bind(this, perHand), key: trendStatus });
          break;
        default:
          break;
      }
    }
    return { data, trendStatus };
  }
  /*
  分时五日切换
   */
  async getTrend(code, period, args = {}) {
    let _data = undefined;
    this.setCode(code, period);
    this.period = period;
    try {
      const { isAppend = false, ...rest } = args;
      const promiseQueue = [];
      if (isAppend) {
        const key = this.queryKeys[period];
        // 增量更新，不删除本地缓存数据
        promiseQueue.push(Promise.resolve(super.update({ fn: this.getTrendData.bind(this, { ...args, key }), key })))
      } else {
        promiseQueue.push(Promise.resolve(super.query({ fn: this.getTrendData, key: this.queryKeys[period] })));
      }
      // promiseQueue.push(Promise.resolve(super.query({fn: this.getPreClosePx, key: this.queryKeys[period + 'ClosePx'],threshold:2000})));
      promiseQueue.push(Promise.resolve(super.query({ fn: this.getPreClosePx, key: this.queryKeys[period + 'ClosePx'], threshold: 3600000 })));
      let data = await Promise.all(promiseQueue);
      const [trendData, closeData] = data;
      const { crc, minTime, ...trend } = trendData;
      const _trendData = this._calcTrendData(trend, code, period);
      data = [{ ..._trendData, crc, minTime }, closeData];
      // console.log(data,'增量添加后的的trend数据，_calcTrendData处理')
      /*
      校验code和period，确保数据一致
      如果不包含code或者period，则不校验
       */
      let dataValid = data.every(a => {
        return (!a.code || a.code === this.code) && (!a.period || a.period === this.period);
      });
      if (dataValid) {
        data.forEach(d => {
          _data = { ..._data, ...d };
        });
        return Promise.resolve(_data);
      }
      return Promise.reject(`getTrend —— code或者period不一致, ${period}和${data.map(a => a.period)}, ${code}和${data.map(a => a.code)}`);
    } catch (e) {
      return Promise.reject(e);
    }
  }
  /*
  设置code
   */
  setCode(code, period) {
    if (this.code !== code) {
      this.clear();
      this.code = code;
    }
    this.period = period;
  }
};
